import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/axios.js';
import placeholder from '../assets/logo-gigi.png';
import drBudi from '../assets/images/dr-budi.svg';
import drDesfa from '../assets/images/dr-desfa.svg';
import authBg from '../assets/images/auth-background.svg';
import defaultProfile from '../assets/images/default-profile-avatar.svg';

function resolveImageUrl(path) {
  if (!path) return placeholder;
  try {
    const p = String(path);
    if (p.startsWith('http') || p.startsWith('/')) return p;
    const base = (api.defaults?.baseURL || '').replace(/\/api\/?$/i, '').replace(/\/$/, '');
    return base ? `${base}/${String(path).replace(/^\//, '')}` : String(path);
  } catch {
    return path;
  }
}

export function ClinicHero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  // Menggunakan 3 foto klinik yang baru ditambahkan
  const [slides, setSlides] = useState([
    { image: '/clinic-photos/slide-1.jpg', label: 'Fasilitas Nyaman' },
    { image: '/clinic-photos/slide-2.png', label: 'Peralatan Modern' },
    { image: '/clinic-photos/slide-3.jpg', label: 'Pelayanan Terbaik' },
  ]);

  // Efek ambil foto dokter dinonaktifkan agar slideshow fokus pada foto klinik
  /*
  useEffect(() => {
    let mounted = true;
    api.get('/public/dokter')
      .then((res) => {
        if (!mounted) return;
        const data = res.data?.data || res.data || [];
        if (Array.isArray(data) && data.length > 0) {
          const photos = data.slice(0, 3).map((d) => ({
            image: resolveImageUrl(
              d.foto || d.photo || d.photo_url || d.avatar ||
              d.user?.photo_url || d.user?.foto || d.user?.photo || d.user?.avatar ||
              d.profile?.photo_url || d.profile?.foto || d.profile?.photo ||
              d.role?.photo_url || d.role?.foto || d.role?.photo || d.role?.avatar
            ),
            label: d.nama || d.label || 'Dokter'
          }));

          if (photos.length > 0) {
            setSlides((prevSlides) => [...photos, ...prevSlides].slice(0, 3));
          }
        }
      })
      .catch(() => {
        // ignore, tetap gunakan placeholder
      });
    return () => { mounted = false; };
  }, []);
  */

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide((index + slides.length) % slides.length);
  };

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    setTouchEnd(e.changedTouches[0].clientX);
    handleSwipe();
  };

  const handleSwipe = () => {
    if (touchStart - touchEnd > 50) {
      nextSlide();
    } else if (touchEnd - touchStart > 50) {
      prevSlide();
    }
  };
  return (
    <section id="beranda">
      <div style={{position: 'absolute', inset: 0, opacity: 0.5}} className="tooth-pattern"></div>
      
      <div className="absolute top-32 left-10 animate-float"></div>
      <div className="absolute bottom-32 right-10 animate-float"></div>
      <div className="absolute top-1/2 right-1/4 animate-pulse-slow"></div>

      <div className="relative max-w-7xl">
        <div className="grid lg:grid-cols-2">
          {/* Text Section */}
          <div className="text-center lg:text-left hero-content">
            <h1 id="hero-title">
              Senyum Cantik,<br className="hero-title-break" />
              Perawatan Nyaman
            </h1>

            <p id="hero-subtitle">
              Daftar berobat gigi dari rumah. Layanan behel, scaling, tambal, cabut,
              dan perawatan gigi anak untuk keluarga Anda.
            </p>

            <div className="hero-cta-wrap">
              <Link to="/pasien/daftar-berobat" className="px-8 py-4 bg-white hero-cta-btn">
                Daftar Berobat Sekarang
              </Link>
            </div>

            <div className="grid grid-cols-3 gap-6 hero-stats">
              <div className="hero-stat-item">
                <div className="hero-stat-num">1000+</div>
                <p className="hero-stat-label">Pasien Terlayani</p>
              </div>
              <div className="hero-stat-item">
                <div className="hero-stat-num">10+</div>
                <p className="hero-stat-label">Dokter Gigi</p>
              </div>
              <div className="hero-stat-item">
                <div className="hero-stat-num">6+</div>
                <p className="hero-stat-label">Layanan Gigi</p>
              </div>
            </div>
          </div>

          {/* Slideshow */}
          <div className="flex justify-center items-center">
            <div className="hero-slider" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
              {slides.map((slide, index) => (
                <div
                  key={index}
                  className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
                >
                  <img src={resolveImageUrl(slide.image)} alt={slide.label} />
                  <div className="hero-slide-label">{slide.label}</div>
                </div>
              ))}

              <div className="hero-slider-controls">
                <button type="button" onClick={prevSlide} className="hero-slide-btn" aria-label="Sebelumnya">‹</button>
                <button type="button" onClick={nextSlide} className="hero-slide-btn" aria-label="Berikutnya">›</button>
              </div>

              <div className="hero-slide-indicators">
                {slides.map((_, index) => (
                  <button
                    key={index}
                    type="button"
                    className={`hero-slide-indicator ${index === currentSlide ? 'active' : ''}`}
                    aria-label={`Slide ${index + 1}`}
                    onClick={() => goToSlide(index)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ClinicHero;
